import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import "./styles.scss";

const formatRatio = (reviewCount: number, searchCount: number): string => {
  if (searchCount === 0) return "∞";
  return `${((reviewCount / searchCount) * 100).toFixed(2)}%`;
};

export interface IKeywordAnalysisCardProps {
  keyword: string;
  searchCountTotal: number;
  reviewMentionCount: number;
  reason: string;
  showDetailButton?: boolean;
  onDetailClick?: () => void;
  rank?: number;
}

export const KeywordAnalysisCard: React.FunctionComponent<
  IKeywordAnalysisCardProps
> = (props) => {
  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`facilityDetailsPage.keywordAnalysis.${key}`);

  const {
    keyword,
    searchCountTotal,
    reviewMentionCount,
    reason,
    showDetailButton = false,
    onDetailClick,
    rank,
  } = props;

  const [isDetailExpanded, setIsDetailExpanded] = useState(false);

  const handleToggleDetail = () => {
    if (onDetailClick) {
      onDetailClick();
    } else {
      setIsDetailExpanded(!isDetailExpanded);
    }
  };

  return (
    <div className="white-border-panel keyword-analysis-card">
      <div className="keyword-analysis-header">
        <h3 className="keyword-analysis-title">{t("suggestedKeyword")}</h3>
      </div>

      <div className="keyword-analysis-keyword">
        {rank && <span className="keyword-rank">#{rank}</span>}
        <span className="keyword">{keyword}</span>
      </div>

      <div className="keyword-analysis-metrics">
        <div className="metric-item">
          <div className="metric-value">
            {searchCountTotal.toLocaleString()}
          </div>
          <div className="metric-label">{t("searchCountTotal")}</div>
        </div>
        <div className="metric-item">
          <div className="metric-value">
            {reviewMentionCount.toLocaleString()}
          </div>
          <div className="metric-label">{t("reviewMentionCount")}</div>
        </div>
        <div className="metric-item">
          <div className="metric-value">
            {formatRatio(reviewMentionCount, searchCountTotal)}
          </div>
          <div className="metric-label">{t("ratio")}</div>
        </div>
      </div>

      <div className="keyword-analysis-reason">
        <div className="reason-text">{reason}</div>
      </div>

      {showDetailButton && (
        <div className="keyword-analysis-footer">
          <button className="btn btn-blue" onClick={handleToggleDetail}>
            {t("seeDetail")}
          </button>
        </div>
      )}
    </div>
  );
};

export default KeywordAnalysisCard;
